export default "__VITE_ASSET__D$R9pxM9__"